import { render } from "./ContactUs.vue?vue&type=template&id=4ce4901e&scoped=true&lang=pug"
import script from "./ContactUs.vue?vue&type=script&lang=ts"
export * from "./ContactUs.vue?vue&type=script&lang=ts"

import "./ContactUs.vue?vue&type=style&index=0&id=4ce4901e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4ce4901e"

export default script